var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import FormField from '../../components/ui/FormField/FormField';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import { getQueryParam } from '../../../utils/urlUtils';
import ResetPasswordCommand from '../../../commands/authentication/ResetPasswordCommand';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import { FormErrorContext } from '../../../FormErrorContext';
import PasswordValidator from '../../components/ui/PasswordValidator/PasswordValidator';
import withRouter from "../../components/ui/MainNavigation/withRouter";
/**
 *
 */
var ResetPassword = /** @class */ (function (_super) {
    __extends(ResetPassword, _super);
    /**
     *
     */
    function ResetPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            submitting: false,
            resetPasswordToken: undefined,
            newPassword: undefined,
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        return _this;
    }
    /**
     *
     */
    ResetPassword.prototype.componentDidMount = function () {
        var resetPasswordToken = getQueryParam('resetToken');
        this.setState({ resetPasswordToken: resetPasswordToken });
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ResetPassword.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     * @returns {*}
     */
    ResetPassword.prototype.render = function () {
        return (React.createElement(Page, { pageName: "reset-password", className: "bg-primary" },
            React.createElement("div", { className: "container vh-100 align-items-center" },
                React.createElement("div", { className: "row h-75 justify-content-center align-items-center" },
                    React.createElement("div", { className: "col-md-6 col-lg-4 text-white" },
                        React.createElement("h2", { className: "card-header justify-content-center" },
                            React.createElement(FormattedMessage, { id: "page.resetpassword.title" })),
                        React.createElement("div", { className: "card-body", style: { fontSize: "large" } },
                            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                                React.createElement(Form, { onSubmit: this.onSubmit, autoComplete: "off" },
                                    React.createElement("fieldset", { disabled: this.state.submitting },
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "newPassword", className: "text-white" },
                                                    React.createElement(FormattedMessage, { id: "page.resetpassword.field.newpassword" })),
                                                React.createElement(Input, { name: "newPassword", id: "newPassword", type: "password", value: this.state.newPassword, required: true, autoComplete: "new-password", onChange: this.onInputChange }))),
                                        React.createElement(PasswordValidator, { value: this.state['newPassword'] }),
                                        React.createElement(Button, { className: "w-100 mb-3 ml-0 font-weight-bolder", color: "dark", type: "submit" },
                                            React.createElement(FormattedMessage, { id: "page.resetpassword.reset" })),
                                        React.createElement("p", { className: "text-center" },
                                            React.createElement("small", { className: "back-link text-center" },
                                                React.createElement(FormattedMessage, { id: "page.resetpassword.to" }),
                                                React.createElement(Link, { to: Routes.LOGIN.path, className: "text-white", style: { textDecoration: "underline" } },
                                                    React.createElement(FormattedMessage, { id: "page.resetpassword.login" })),
                                                ".")))))))))));
    };
    /**
     *
     * @param user
     */
    ResetPassword.prototype.onSuccess = function (user) {
        this.setState({ submitting: false });
        this.props.router.navigate(Routes.LOGIN.getPath());
    };
    /**
     *
     * @param error
     */
    ResetPassword.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    /**
     *
     * @param e
     */
    ResetPassword.prototype.onSubmit = function (e) {
        e ? e.preventDefault() : null;
        if (this.state.submitting) {
            return;
        }
        this.setState({ errors: null, submitting: true });
        var intl = this.props.intl;
        var command = new ResetPasswordCommand();
        command.execute(this.state.resetPasswordToken, this.state.newPassword, intl).then(this.onSuccess, this.onError);
    };
    /**
     *
     * @param e
     */
    ResetPassword.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };
    return ResetPassword;
}(React.Component));
ResetPassword.contextType = ApplicationContext;
export default injectIntl(withRouter(ResetPassword));
